import { render } from "./pegawai-detail-custom.vue?vue&type=template&id=5f4bbd00&scoped=true"
import script from "./pegawai-detail-custom.vue?vue&type=script&lang=js"
export * from "./pegawai-detail-custom.vue?vue&type=script&lang=js"

import "./pegawai-detail-custom.vue?vue&type=style&index=0&id=5f4bbd00&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4bbd00"]])

export default __exports__